const EMPTY = Object.freeze({
    isWalletModalOpen: false,
    selectedConnector: undefined,
});
let snapshot = EMPTY;
const listeners = new Set();
let writer = null;
const emit = () => listeners.forEach(l => l());
export const connectModalStore = {
    subscribe(listener) {
        listeners.add(listener);
        return () => listeners.delete(listener);
    },
    getSnapshot() {
        return snapshot;
    },
    setSelectedConnector(connector) {
        writer?.(connector);
    },
    _syncOpen(open) {
        if (snapshot.isWalletModalOpen === open)
            return;
        snapshot = { ...snapshot, isWalletModalOpen: open };
        emit();
    },
    _syncSelectedConnector(connector) {
        if (snapshot.selectedConnector === connector)
            return;
        snapshot = { ...snapshot, selectedConnector: connector };
        emit();
    },
    _registerWriter(fn) {
        writer = fn;
        return () => {
            if (writer === fn)
                writer = null;
        };
    },
};
